import React, { useEffect, useRef } from 'react'
import { Button, Form, Typography } from 'antd'

import IntlMessages from '../../../../util/IntlMessages'
import CodeField, { ICodeFieldHandle } from './code-field'

const { Paragraph, Link } = Typography

export interface IMfaStepProps {
  isBusy: boolean
  onSubmit: (code: string) => void
  onCodeChanged: () => void
  onBackToSignin: () => void
}

const MfaStep = ({ isBusy, onSubmit, onCodeChanged, onBackToSignin }: IMfaStepProps): React.ReactElement => {
  const [form] = Form.useForm()
  const inputRef = useRef<ICodeFieldHandle>(null)
  const wasBusy = useRef(false)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  // An attempt that ends without leaving the page was a rejected code. The boxes are disabled
  // while it runs, which drops the focus, and they still hold the code that was just refused.
  useEffect(() => {
    if (wasBusy.current && !isBusy) {
      form.resetFields()
      // After the reset, not with it: antd rebuilds the boxes for the cleared value, and a
      // focus call made before that lands on an input the rebuild throws away.
      window.requestAnimationFrame(() => inputRef.current?.focus())
    }
    wasBusy.current = isBusy
  }, [isBusy])

  return (
    <>
      <Form name="connect-with-email" form={form} layout="horizontal" onFinish={(values) => onSubmit(values.code)}>
        <CodeField
          ref={inputRef}
          disabled={isBusy}
          requiredMessageId="signin.mfaCodeRequired"
          dataQa="mfa-code"
          className="mfa-code-item"
          onChanged={onCodeChanged}
          // A complete code is the whole of what this step asks for: nothing to confirm.
          onComplete={() => form.submit()}
        />
        <Form.Item>
          <Button size="large" type="primary" htmlType="submit" disabled={isBusy} loading={isBusy} data-qa="mfa-submit" block>
            <IntlMessages id="components.modal.verify" />
          </Button>
        </Form.Item>
      </Form>
      <Paragraph className="auth-sidebar-login">
        <Link onClick={onBackToSignin} data-qa="mfa-back-to-signin">
          <IntlMessages id="signin.backToSignin" />
        </Link>
      </Paragraph>
    </>
  )
}

export default MfaStep
